// components/Breadcrumbs.jsx
import { Link, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <div className="ml-0 sm:ml-6 md:ml-10 lg:ml-14 xl:ml-16 semibold text-sm text-black" style={{marginTop:"5rem"}}>
    {/* // <div className="ml-0 sm:ml-6 md:ml-10 lg:ml-14 xl:ml-16 semibold text-sm text-black"> */}
      <Link to="/" className="text-gray-400 hover:underline">Home</Link>
      {pathnames.map((value, index) => {
        const to = "/" + pathnames.slice(0, index + 1).join("/");
        const isLast = index === pathnames.length - 1;
        const formatted = decodeURIComponent(value.replace(/-/g, " "));

        return (
          <span key={to}>
            <span className="text-gray-400"> / </span>
            {isLast ? (
              <span className="font-bold">{formatted}</span>
            ) : (
              <Link to={to} className="text-gray-400 hover:underline">
                {formatted}
              </Link>
            )}
          </span>
        );
      })}
    </div>
  );
}

export default Breadcrumbs;
